import {
    SET_PROFILE_IMAGE,
    SET_PROFILE_IMAGE_PENDING,
    UPLOAD_PROFILE_PICTURE,
} from '../actions/types';
import { PostDispatch } from '../types';

interface ImageState {
    [id: string]: string;
}

const INITIAL_IMAGE_STATE: ImageState = {};

interface ImageActionPayload {
    imageId: string;
    imageLink: string;
}

const ImageReducer = (
    state = INITIAL_IMAGE_STATE,
    action: PostDispatch
): ImageState => {
    const uploadPayload: ImageActionPayload =
        action.payload as ImageActionPayload;
    const getPayload: ImageActionPayload = action.payload as ImageActionPayload;
    switch (action.type) {
        case UPLOAD_PROFILE_PICTURE:
            return {
                ...state,
                [uploadPayload.imageId]: uploadPayload.imageLink,
            };
        case SET_PROFILE_IMAGE:
            return {
                ...state,
                [getPayload.imageId]: getPayload.imageLink,
            };
        case SET_PROFILE_IMAGE_PENDING: {
            return state[getPayload.imageId] === ''
                ? state
                : {
                      ...state,
                      [getPayload.imageId]: '',
                  };
        }
        default:
            return state;
    }
};

export default ImageReducer;
